import {useEffect} from "react";
import {useMap} from "@vis.gl/react-google-maps";
import {Marker} from "../types/types";

type Props = {
    markers: Marker[];
    center: { lat: number; lng: number };
    shouldRecenter: boolean;
    onRecentered: () => void;
}

const MapLogicHandler: React.FC<Props> = ({markers, center, shouldRecenter, onRecentered}) => {
    const map = useMap();
    useEffect(() => {
        if (!map || markers.length === 0) return;

        if (shouldRecenter) {
            console.log('🌟 re-centering the map:', center);
            map.panTo(center);
            onRecentered();
        }
        if (markers.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            markers.forEach((m) => {
                bounds.extend(new google.maps.LatLng(m.lat, m.lng));
            });
            map.fitBounds(bounds, {
                top: 50,
                left: 50,
                right: 50,
                bottom: 50
            });
        }
    }, [map, markers, center, shouldRecenter, onRecentered]);

    return null;
}

export default MapLogicHandler;